import type { AccountsWalletsTranslations } from "@/shared/lang/interfaces/accountsWallets";

/**
 * Maps structured_data field keys (from API / payment method config) to translation keys
 * for labels in the account detail modal. Used with getStructuredDataDisplayEntries translateLabel.
 */
export const STRUCTURED_FIELD_TO_TKEY: Record<string, keyof AccountsWalletsTranslations> = {
  bank_name: "structured_bank",
  bankName: "structured_bank",
  institution_name: "structured_institution",
  account_number: "structured_account_number",
  accountNumber: "structured_account_number",
  account_type: "structured_account_type",
  accountType: "structured_account_type",
  llaveBreB: "structured_llave_bre_b",
  numeroCelularNequi: "structured_celular_nequi",
  bancoAch: "structured_bank",
  tipoCuenta: "structured_account_type",
  numeroCuenta: "structured_account_number",
  tipoDocumento: "structured_document_type",
  numeroDocumento: "structured_document_number",
  banco: "structured_bank",
  rut: "structured_rut",
  email: "structured_email",
  numeroCci: "structured_cci",
  documentoIdentidad: "structured_identity_document",
  numeroCelularYape: "structured_celular_yape",
  numeroCelularPlin: "structured_celular_plin",
  tipoLlavePix: "structured_pix_key_type",
  llavePix: "structured_pix_key",
  clabe: "structured_clabe",
  numeroCuentaIban: "structured_account_iban",
  cbuCvu: "structured_cbu_cvu",
  cbu: "structured_cbu",
  cvu: "structured_cvu",
  direccionWallet: "structured_wallet_address",
  routingNumber: "structured_routing_number",
  swiftBic: "structured_swift_bic",
  direccionBanco: "structured_bank_address",
  emailOTelefonoZelle: "structured_email_phone_zelle",
  iban: "structured_iban",
  tipoIdentificadorFps: "structured_fps_id_type",
  identificadorFps: "structured_fps_id",
  codigoChats: "structured_chats_code",
  idAlipay: "structured_alipay_id",
  idWechat: "structured_wechat_id",
  numeroCelular: "structured_celular",
  binancePayUid: "structured_binance_pay_uid",
  binancePayEmail: "structured_binance_pay_email",
};
